export default {
      id: "corp-usage",
      viewBox: "0 0 15 12",
      url: __webpack_public_path__ + "img/icons.adde2a28.svg#corp",
      toString: function () {
        return this.url;
      }
    }